<template>
  <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String
    },
    input: {
      type: String
    },
    inputName: {
      type: String
    },
    inputMask: {
      type:  Object,
      // require:
    }
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    this.keyboard = new Keyboard({
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      inputName: this.inputName,
      theme: "hg-theme-default hg-theme-ios",
       layout: {
        default: [
          "q w e r t y u i o p {bksp}",
          "a s d f g h j k l",
          "{shift} z x c v b n m , .",
          "{alt} @ .com .com.br {space}"
        ],
        shift: [
          "Q W E R T Y U I O P {bksp}",
          "A S D F G H J K L",
          "{shiftactivated} Z X C V B N M , . {shiftactivated}",
          "{alt} .COM {space} .COM.BR"
          // "{alt} {smileys} {space} {altright} {downkeyboard}"
        ],
        alt: [
          "1 2 3 4 5 6 7 8 9 0 {bksp}",
          `@ # $ & * ( ) ' "`,
          "{shift} % - + = / ; : ! ?",
          "{default}"
        ],
        // smileys: [
        //   "😀 😊 😅 😂 🙂 😉 😍 😛 😠 😎 {bksp}",
        //   `😏 😬 😭 😓 😱 😪 😬 😴 😯 {enter}`,
        //   "😐 😇 🤣 😘 😚 😆 😡 😥 😓 🙄 {shift}",
        //   "{default} {smileys} {space} {altright} {downkeyboard}"
        // ]
      },
      display: {
        "{alt}": ".?123",
        "{shift}": "⇧",
        "{shiftactivated}": "⇧",
        "{bksp}": "APAGAR",
        "{altright}": ".?123",
        "{downkeyboard}": "🞃",
        "{space}": "Espaço",
        "{default}": "ABC",
        "{back}": "⇦",
      }
    });
  },
  methods: {
    onChange(input) {
      this.$emit("onChange", input);
    },
    onKeyPress(button) {
        let currentLayout = this.keyboard.options.layoutName;
        let layoutName;

        switch (button) {
          case "{shift}":
          case "{shiftactivated}":
          case "{default}":
            layoutName = currentLayout === "default" ? "shift" : "default";
            break;

          case "{alt}":
          case "{altright}":
            layoutName = currentLayout === "alt" ? "default" : "alt";
            break;

          case "{smileys}":
            layoutName = currentLayout === "smileys" ? "default" : "smileys";
            break;

          default:
          break;
        }

        if (layoutName) {
          this.keyboard.setOptions({
            layoutName: layoutName
          });
        }

      // this.$emit("onKeyPress", button);

      /**
       * If you want to handle the shift and caps lock buttons
       */
      // if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    // handleShift() {
    //   let currentLayout = this.keyboard.options.layoutName;
    //   let shiftToggle = currentLayout === "default" ? "shift" : "default";

    //   this.keyboard.setOptions({
    //     layoutName: shiftToggle,
    //   });
    // }
  },
  watch: {
    inputName(inputName) {
      this.keyboard.setOptions({ inputName });
    },
    input(input) {
      this.keyboard.setInput(input);
    }
  }
};
</script>


<style scoped>
.simple-keyboard {
    position: absolute;
    width: 100%;
    bottom: 20%;
    z-index: 999;
}
</style>
